import { SelectOption } from 'basics/options/options.types';
import { HostProvider } from 'generated/event.types';

const eventHostProviderOptions: SelectOption[] = [
  { id: HostProvider.zoom, label: 'Zoom Meeting' },
  { id: HostProvider.other, label: 'Existing link' },
  { id: HostProvider.brightcove, label: 'Brightcove Livestream' },
  { id: HostProvider.teams, label: 'Microsoft Teams Meeting' },
];

export default eventHostProviderOptions;
